"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES = void 0;
exports.default = TextLockup;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _box = _interopRequireDefault(require("@ux/box"));
var _text = _interopRequireDefault(require("@ux/text"));
var _accessories = require("./accessories");
var _textProps = require("./textProps");
const _excluded = ["className", "emphasis", "icon", "eyebrow", "title", "titleLevel", "children", "size"];
/* eslint-disable no-process-env, no-console */
const UX_TEXT_LOCKUP_CLASSNAME = 'ux-text-lockup';
const TITLE_LEVELS = [1, 2, 3, 4, 5, 6];
const GAP_SIZE = 'sm';
const SIZES = exports.SIZES = Object.keys(_textProps.textProps);

/**
 * Create a text-lockup component
 *
 * @param { Object } props - Configuration object
 * @param { String } className - Optional class name for placement
 * @param { String } emphasis - Provides an icon colored by the given emphasis
 * @param { String } size - Used to get values from textProps by set size
 * @param { Node } icon - Node for setting a custom icon that can be used with or without emphasis
 * @param { Node } eyebrow - Node for eyebrow
 * @param { Node } title - Node for title
 * @param { Number } titleLevel - Used to create heading tag if passed
 * @param { Node } children - Node for child elements
 * @returns { Component } - <TextLockup/>
 */
function TextLockup(_ref) {
  let {
      className,
      emphasis,
      icon,
      eyebrow,
      title,
      titleLevel,
      children,
      size = 'md'
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const textProps = _textProps.textProps[size];
  const iconProps = {
    as: title ? textProps.title.as : textProps.paragraph.as,
    size: title ? textProps.title.size : textProps.paragraph.size,
    className: (0, _classnames.default)(`${UX_TEXT_LOCKUP_CLASSNAME}--icon`)
  };
  const eyeBrowProps = {
    as: textProps.eyebrow.as,
    size: textProps.eyebrow.size,
    className: `${UX_TEXT_LOCKUP_CLASSNAME}--eyebrow`
  };
  const titleProps = {
    as: textProps.title.as,
    size: textProps.title.size,
    className: `${UX_TEXT_LOCKUP_CLASSNAME}--title`
  };
  const paraGraphProps = {
    as: textProps.paragraph.as,
    size: textProps.paragraph.size,
    className: `${UX_TEXT_LOCKUP_CLASSNAME}--body`
  };
  if (!icon && !eyebrow && !title && !children) return;
  if (process.env.NODE_ENV !== 'production' && eyebrow && icon) {
    console.warn('Warning: Eyebrow and Icon should not be used together. Please use one.');
  }
  const classNames = (0, _classnames.default)(UX_TEXT_LOCKUP_CLASSNAME, className, {
    [`${UX_TEXT_LOCKUP_CLASSNAME}--${emphasis}`]: emphasis && _accessories.ACCESSORIES[emphasis]
  });
  const createElementByTitleLevel = level => {
    return TITLE_LEVELS.includes(level) ? _text.default[`h${level}`] : _text.default.div;
  };
  const IconElem = createElementByTitleLevel(titleLevel);
  const TitleElem = createElementByTitleLevel(titleLevel);
  return /*#__PURE__*/_react.default.createElement(_box.default, (0, _extends2.default)({
    "data-version": "2400",
    className: classNames,
    gap: GAP_SIZE,
    orientation: "horizontal"
  }, rest), !eyebrow && (emphasis || icon) && /*#__PURE__*/_react.default.createElement(IconElem, (0, _extends2.default)({
    role: "presentation"
  }, iconProps), emphasis ? icon || /*#__PURE__*/_react.default.createElement(_accessories.ACCESSORIES[emphasis]) : icon), (eyebrow || title || children) && /*#__PURE__*/_react.default.createElement(_box.default, {
    className: (0, _classnames.default)(`${UX_TEXT_LOCKUP_CLASSNAME}--text`),
    gap: GAP_SIZE,
    orientation: "vertical"
  }, !icon && eyebrow && /*#__PURE__*/_react.default.createElement(_text.default.div, eyeBrowProps, eyebrow), title && /*#__PURE__*/_react.default.createElement(TitleElem, titleProps, title), children && /*#__PURE__*/_react.default.createElement(_text.default.div, paraGraphProps, /*#__PURE__*/_react.default.createElement(_box.default, {
    gap: GAP_SIZE,
    orientation: "vertical"
  }, children))));
}
TextLockup.propTypes = {
  /** Optional class name for placement */
  className: _propTypes.default.string,
  /** Provides an icon colored by the given emphasis */
  emphasis: _propTypes.default.oneOf(Object.keys(_accessories.ACCESSORIES)),
  /** Size of type lockup set  */
  size: _propTypes.default.oneOf(SIZES).isRequired,
  /** Custom icon that can be used with or without emphasis */
  icon: _propTypes.default.node,
  /** Text for eyebrow */
  eyebrow: _propTypes.default.node,
  /** Text for title */
  title: _propTypes.default.node,
  /** Title heading tag level (ex. h1-h6)*/
  titleLevel: _propTypes.default.oneOf(TITLE_LEVELS),
  /** Text for paragraph */
  children: _propTypes.default.node
};